import React from 'react';
import PropTypes from 'prop-types';
import { KeyboardDatePicker } from '@material-ui/pickers';

const FormDateField = ({
  input,
  label,
  meta: { touched, error },
  disabled,
}) => (
    <KeyboardDatePicker
      label={label}
      error={touched && error ? true : false}
      helperText={touched && error}
      margin="dense"
      InputLabelProps={{
        shrink: true,
      }}
      clearable
      okLabel="OK"
      cancelLabel="Anuluj"
      clearLabel="Wyczyść"
      invalidLabel="Wybierz ..."
      onChange={value => input.onChange(value)}
      format="dd.MM.yyyy"
      value={input.value}
      autoOk
      views={["year", "month", "date"]}
      disableFuture
      openTo="year"
      disabled={disabled === true}
    />
  );

FormDateField.propTypes = {
  input: PropTypes.object,
  label: PropTypes.string,
  meta: PropTypes.object,
  disabled: PropTypes.bool
};

export default FormDateField;



// WEBPACK FOOTER //
// ./src/components/legacyForm/FormDateField.js